import React, { useState } from "react";
import { Container } from "@/Components/Common/Tailwind";
import { useNavigate } from "react-router-dom";

import { API } from "../../api";
import NavBottomBar from "../../Components/Common/NavBottomBar";
import { SUBDOMAIN } from "../../assets/meta/meta";
import MobileViewContainer from "../../Components/MobileViewContainer";
import { useUserStore } from "../../store/store";

const ShopList = () => {
  const navigate = useNavigate();
  const [user] = useUserStore((state) => [state.user]);

  const [products, setProducts] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const is_test = SUBDOMAIN === "test" ? true : false;
        const query = is_test ? "?is_test=true" : "";

        const response = await API.get(`/shop/product/${query}`);
        const data = response.data;

        console.log("get shop products", data);
        setProducts(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return (
    <MobileViewContainer>
      <React.Fragment>
        {/* Page Header */}
        <div className="px-4 pt-4 pb-2">
          <h1 className="text-xl font-bold" style={{ fontFamily: "Gmarket-B" }}>쇼핑하기</h1>
          <p className="text-sm text-gray-500 mt-1">다양한 라이프스타일 상품을 만나보세요.</p>
        </div>

        {/* Product List */}
        <Container>
          <div className="px-0 pb-32">
            {products.map((item, idx) => {
              return (
                <div
                  key={idx}
                  className="bg-white rounded-xl border border-gray-200 p-4 mb-3 cursor-pointer"
                  style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}
                  onClick={() => {
                    navigate(`/shop/${item.id}`, { state: { product: item } });
                  }}
                >
                  <div className="flex items-start gap-4">
                    {/* Product Image */}
                    <div
                      className="flex-shrink-0 w-32 aspect-square rounded-lg overflow-hidden bg-gray-50 flex items-center justify-center"
                    >
                      <img
                        src={item.thumbnail}
                        alt={item.name}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Product Info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col justify-between h-full">
                        <div>
                          <h3
                            className="text-base font-medium mb-1 truncate"
                            style={{ fontFamily: "Gmarket-M" }}
                          >
                            {item.name}
                          </h3>
                          {item.no_sale_price > item.price && item.sale_rate > 0 && (
                            <div className="flex items-center gap-2 mb-1">
                              <span className="text-xs text-gray-400 line-through">
                                {new Intl.NumberFormat().format(item.no_sale_price)}원
                              </span>
                              <span className="text-xs font-bold text-red-500">
                                {Math.round(item.sale_rate)}%
                              </span>
                            </div>
                          )}
                          <p
                            className="text-lg font-bold"
                            style={{
                              fontFamily: "Gmarket-B",
                              color: "#111827"
                            }}
                          >
                            {new Intl.NumberFormat().format(item.price)}원
                          </p>
                        </div>

                        {/* Status */}
                        {item.remaining_stock <= 0 && (
                          <div className="text-red-500 font-bold text-sm mt-3">품절</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>

        <NavBottomBar activeBar={4} />
      </React.Fragment>
    </MobileViewContainer>
  );
};

export default ShopList;
